<div class="card shadow-sm">
  <div class="card-header">
    <h3 class="card-title">Changes Log</h3>
  </div>
  <div class="card-body">
    <div class="row g-3">
      <div class="col-12 mt-2">
        @if (formattedLogs.length > 0) {
          <div class="control-logs">
            @for (logEntry of formattedLogs; track logEntry) {
              <div class="item-logs" style="margin-bottom: 15px;">
                <p> <strong>{{ getUserDisplayName(logEntry.log) }}</strong> - {{ formatDate(logEntry.log.createTime) }} </p>
                @for (change of logEntry.changes; track change) {
                  <div style="margin-top: 10px;">
                    <p>{{ change }}</p>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
